/* tslint:disable */
/* eslint-disable */
/**
 * Famifarm-API
 * Famifarm API specification
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    Facility,
    FacilityFromJSON,
    FacilityToJSON,
    PackagingFilmBatch,
    PackagingFilmBatchFromJSON,
    PackagingFilmBatchToJSON,
} from '../models';

export interface CreatePackagingFilmBatchRequest {
    packagingFilmBatch: PackagingFilmBatch;
    facility: Facility;
}

export interface DeletePackagingFilmBatchRequest {
    facility: Facility;
    packagingFilmBatchId: string;
}

export interface FindPackagingFilmBatchRequest {
    facility: Facility;
    packagingFilmBatchId: string;
}

export interface ListPackagingFilmBatchesRequest {
    facility: Facility;
    firstResult?: number;
    maxResults?: number;
    includePassive?: boolean;
}

export interface UpdatePackagingFilmBatchRequest {
    packagingFilmBatch: PackagingFilmBatch;
    facility: Facility;
    packagingFilmBatchId: string;
}

/**
 * 
 */
export class PackagingFilmBatchesApi extends runtime.BaseAPI {

    /**
     * Create new packaging film batch
     */
    async createPackagingFilmBatchRaw(requestParameters: CreatePackagingFilmBatchRequest): Promise<runtime.ApiResponse<PackagingFilmBatch>> {
        if (requestParameters.packagingFilmBatch === null || requestParameters.packagingFilmBatch === undefined) {
            throw new runtime.RequiredError('packagingFilmBatch','Required parameter requestParameters.packagingFilmBatch was null or undefined when calling createPackagingFilmBatch.');
        }

        if (requestParameters.facility === null || requestParameters.facility === undefined) {
            throw new runtime.RequiredError('facility','Required parameter requestParameters.facility was null or undefined when calling createPackagingFilmBatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("BearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/{facility}/packagingFilmBatches`.replace(`{${"facility"}}`, encodeURIComponent(String(requestParameters.facility))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PackagingFilmBatchToJSON(requestParameters.packagingFilmBatch),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PackagingFilmBatchFromJSON(jsonValue));
    }

    /**
     * Create new packaging film batch
     */
    async createPackagingFilmBatch(requestParameters: CreatePackagingFilmBatchRequest): Promise<PackagingFilmBatch> {
        const response = await this.createPackagingFilmBatchRaw(requestParameters);
        return await response.value();
    }

    /**
     * Deletes a packaging film batch
     */
    async deletePackagingFilmBatchRaw(requestParameters: DeletePackagingFilmBatchRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.facility === null || requestParameters.facility === undefined) {
            throw new runtime.RequiredError('facility','Required parameter requestParameters.facility was null or undefined when calling deletePackagingFilmBatch.');
        }

        if (requestParameters.packagingFilmBatchId === null || requestParameters.packagingFilmBatchId === undefined) {
            throw new runtime.RequiredError('packagingFilmBatchId','Required parameter requestParameters.packagingFilmBatchId was null or undefined when calling deletePackagingFilmBatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("BearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/{facility}/packagingFilmBatches/{packagingFilmBatchId}`.replace(`{${"facility"}}`, encodeURIComponent(String(requestParameters.facility))).replace(`{${"packagingFilmBatchId"}}`, encodeURIComponent(String(requestParameters.packagingFilmBatchId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a packaging film batch
     */
    async deletePackagingFilmBatch(requestParameters: DeletePackagingFilmBatchRequest): Promise<void> {
        await this.deletePackagingFilmBatchRaw(requestParameters);
    }

    /**
     * Find a packaging film batch
     */
    async findPackagingFilmBatchRaw(requestParameters: FindPackagingFilmBatchRequest): Promise<runtime.ApiResponse<PackagingFilmBatch>> {
        if (requestParameters.facility === null || requestParameters.facility === undefined) {
            throw new runtime.RequiredError('facility','Required parameter requestParameters.facility was null or undefined when calling findPackagingFilmBatch.');
        }

        if (requestParameters.packagingFilmBatchId === null || requestParameters.packagingFilmBatchId === undefined) {
            throw new runtime.RequiredError('packagingFilmBatchId','Required parameter requestParameters.packagingFilmBatchId was null or undefined when calling findPackagingFilmBatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("BearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/{facility}/packagingFilmBatches/{packagingFilmBatchId}`.replace(`{${"facility"}}`, encodeURIComponent(String(requestParameters.facility))).replace(`{${"packagingFilmBatchId"}}`, encodeURIComponent(String(requestParameters.packagingFilmBatchId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PackagingFilmBatchFromJSON(jsonValue));
    }

    /**
     * Find a packaging film batch
     */
    async findPackagingFilmBatch(requestParameters: FindPackagingFilmBatchRequest): Promise<PackagingFilmBatch> {
        const response = await this.findPackagingFilmBatchRaw(requestParameters);
        return await response.value();
    }

    /**
     * List all packaging film batches
     */
    async listPackagingFilmBatchesRaw(requestParameters: ListPackagingFilmBatchesRequest): Promise<runtime.ApiResponse<Array<PackagingFilmBatch>>> {
        if (requestParameters.facility === null || requestParameters.facility === undefined) {
            throw new runtime.RequiredError('facility','Required parameter requestParameters.facility was null or undefined when calling listPackagingFilmBatches.');
        }

        const queryParameters: any = {};

        if (requestParameters.firstResult !== undefined) {
            queryParameters['firstResult'] = requestParameters.firstResult;
        }

        if (requestParameters.maxResults !== undefined) {
            queryParameters['maxResults'] = requestParameters.maxResults;
        }

        if (requestParameters.includePassive !== undefined) {
            queryParameters['includePassive'] = requestParameters.includePassive;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("BearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/{facility}/packagingFilmBatches`.replace(`{${"facility"}}`, encodeURIComponent(String(requestParameters.facility))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PackagingFilmBatchFromJSON));
    }

    /**
     * List all packaging film batches
     */
    async listPackagingFilmBatches(requestParameters: ListPackagingFilmBatchesRequest): Promise<Array<PackagingFilmBatch>> {
        const response = await this.listPackagingFilmBatchesRaw(requestParameters);
        return await response.value();
    }

    /**
     * Updates a packaging film batch
     */
    async updatePackagingFilmBatchRaw(requestParameters: UpdatePackagingFilmBatchRequest): Promise<runtime.ApiResponse<PackagingFilmBatch>> {
        if (requestParameters.packagingFilmBatch === null || requestParameters.packagingFilmBatch === undefined) {
            throw new runtime.RequiredError('packagingFilmBatch','Required parameter requestParameters.packagingFilmBatch was null or undefined when calling updatePackagingFilmBatch.');
        }

        if (requestParameters.facility === null || requestParameters.facility === undefined) {
            throw new runtime.RequiredError('facility','Required parameter requestParameters.facility was null or undefined when calling updatePackagingFilmBatch.');
        }

        if (requestParameters.packagingFilmBatchId === null || requestParameters.packagingFilmBatchId === undefined) {
            throw new runtime.RequiredError('packagingFilmBatchId','Required parameter requestParameters.packagingFilmBatchId was null or undefined when calling updatePackagingFilmBatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("BearerAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/{facility}/packagingFilmBatches/{packagingFilmBatchId}`.replace(`{${"facility"}}`, encodeURIComponent(String(requestParameters.facility))).replace(`{${"packagingFilmBatchId"}}`, encodeURIComponent(String(requestParameters.packagingFilmBatchId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: PackagingFilmBatchToJSON(requestParameters.packagingFilmBatch),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PackagingFilmBatchFromJSON(jsonValue));
    }

    /**
     * Updates a packaging film batch
     */
    async updatePackagingFilmBatch(requestParameters: UpdatePackagingFilmBatchRequest): Promise<PackagingFilmBatch> {
        const response = await this.updatePackagingFilmBatchRaw(requestParameters);
        return await response.value();
    }

}
